export default __webpack_public_path__ + "static/media/Path1221@2x.c4e9c306.png";